import Flickity from 'flickity'

export default el => {
  const cardListEl = el.querySelector('.js-image-card-list')
  const flickity = new Flickity(cardListEl, {
    watchCSS: true,
    cellSelector: '.carousel-cell',
    cellAlign: 'left',
    contain: true,
    prevNextButtons: false,
    pageDots: false,
  })
  return flickity
}
